import React, { useEffect, useState, useReducer, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
   Input, Table, Space, Tooltip, Button, Popconfirm,
   Modal, Spin, Empty, Skeleton
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import * as AntDIcons from '@ant-design/icons';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import uuid from 'react-uuid';
import moment from 'moment';

import Create from './Components/Create';
import Edit from './Components/Edit';
import Submissions from './Components/Submissions';
import '../common/BraineeModule.css';
import { isPlagiarismCheckerEnabled } from './plagiarismUtils';

export function Projects() {
   const navigate = useNavigate();

   const search = window.location.search;
   const query = new URLSearchParams(search);
   const subject = query.get('id');
   const subjectname = query.get('name');
   const user_id = query.get('staff') ?? localStorage.getItem('selected-teacher') ?? Utils.getCurrentUserInfo(Enums.UserInfo.id);

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [homeworkList, setHomeworkList] = useState([]);
   const [subjectList, setSubjectList] = useState([]);
   const [sectionList, setSectionList] = useState([]);
   const [level, setLevel] = useState(null);
   const [levelSubmission, setLevelSubmission] = useState(null);
   const [plagiarismCheckerEnabled, setPlagiarismCheckerEnabled] = useState(false);
   const [section, setSection] = useState(null);
   // const [subject, setSubject] = useState(null);
   const [homeworkListLoading, setHomeworkListLoading] = useState(false);
   const [isCompactListView, setIsCompactListView] = useState(() => window.innerWidth <= 768);
   const [secsubLoading, setSecSubLoading] = useState(false);

   const [createModalVisible, setCreateModalVisible] = useState(false);
   const [editModalVisible, setEditModalVisible] = useState(false);
   const [hsModalVisible, setHSModalVisible] = useState(false);

   const [homeworkTitle, setHomeworkTitle] = useState("");
   const [homeworkID, setHomeoworkID] = useState("");
   const [homeworkData, setHomeworkData] = useState(null);

   const [creating, setCreating] = useState(false);
   const [updating, setUpdating] = useState(false);
   const [hsLoading, setHSLoading] = useState(false);

   const user_full_name = Utils.getCurrentUserInfo(Enums.UserInfo.fullname);
   const [userList, setUserList] = useState([]);
   // const [user_id, setUserId] = useState(Utils.getCurrentUserInfo(Enums.UserInfo.id));

   const { confirm } = Modal;

   // const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   useEffect(() => {
      Utils.verifyJwt();

      if (user_role.toLowerCase() === "admin") {
         var url = `${process.env.REACT_APP_API_LESSON}/listAllStaff`;
         axios.get(url).then((response) => {
            if (response.data) {
               let data = response.data;
               var users = data.filter((d) => d.id !== Number(user_id)).sort((a, b) => {
                  var aVal = a["first_Name"];
                  var bVal = b["first_Name"];
                  switch (typeof aVal) {
                     case 'string':
                        return aVal.localeCompare(bVal);
                     case 'number':
                        return aVal - bVal;
                     default:
                        throw new Error("Unsupported value to sort by");
                  }
               });
               var final = data.filter((d) => d.id === Number(user_id));
               Array.prototype.push.apply(final, users);
               setUserList(final)
            }
         }, (error) => {
            // setLoading(false);
            console.log(error.message);
         });
      }

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');
      else
         handleSearchHomeworks(user_id);

   }, []);

   useEffect(() => {
      const handleResize = () => {
         setIsCompactListView(window.innerWidth <= 768);
      };

      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
               {/* <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button> */}
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const HomeworkListColumns = [
      {
         title: '',
         dataIndex: 'id',
         key: 'id',
         hidden: true,
      },
      {
         title: '',
         dataIndex: 'class_id',
         key: 'class_id',
         hidden: true,
      },
      {
         title: '',
         dataIndex: 'section_id',
         key: 'section_id',
         hidden: true,
      },
      {
         title: '',
         dataIndex: 'subject_id',
         key: 'subject_id',
         hidden: true,
      },
      {
         title: '',
         dataIndex: 'created_by',
         key: 'created_by',
         hidden: true,
      },
      {
         title: '',
         dataIndex: 'level_desc',
         key: 'level_desc',
         hidden: true,
      },
      {
         title: 'Title',
         key: 'title',
         dataIndex: 'title',
         sorter: (a, b) => { return a.title.localeCompare(b.title) },
         ...getColumnSearchProps('title'),
         ellipsis: {
            showTitle: false,
         },
         render: title => (
            <Tooltip placement="right" title={title}>
               <span style={{ cursor: "default" }}>{title}</span>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'Level',
         key: 'level',
         dataIndex: 'level',
         sorter: (a, b) => { return (a.level === null ? '' : a.level).localeCompare(b.level === null ? '' : b.level) },
         width: '8%'
      },
      {
         title: 'Sections',
         key: 'section_names',
         dataIndex: 'section_names',
         sorter: (a, b) => { return (a.section_names === null ? '' : a.section_names).localeCompare(b.section_names === null ? '' : b.section_names) },
         ellipsis: {
            showTitle: false,
         },
         render: section_names => (
            <Tooltip placement="left" title={section_names}>
               <span style={{ cursor: "default" }}>{section_names}</span>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Subject',
         key: 'subject',
         dataIndex: 'subject',
         sorter: (a, b) => { return a.subject.localeCompare(b.subject) },
         ...getColumnSearchProps('subject'),
         ellipsis: {
            showTitle: false,
         },
         render: object => (
            <Tooltip placement="right" title={object}>
               <span style={{ cursor: "default" }}>{object}</span>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Created By',
         key: 'teacher',
         dataIndex: 'teacher',
         sorter: (a, b) => { return a.teacher.localeCompare(b.teacher) },
         ellipsis: {
            showTitle: false,
         },
         render: object => (
            <Tooltip placement="right" title={object}>
               <span style={{ cursor: "default" }}>{object}</span>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Project Date',
         key: 'homework_date',
         dataIndex: 'homework_date',
         sorter: (a, b) => { return a.homework_date.localeCompare(b.homework_date) },
         width: '12%'
      },
      {
         title: 'Submit Date',
         key: 'submit_date',
         dataIndex: 'submit_date',
         sorter: (a, b) => { return a.submit_date.localeCompare(b.submit_date) },
         width: '12%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               <Space size="small">
                  <Tooltip placement="top" title='Edit'>
                     <AntDIcons.EditOutlined color='#4abec7' style={{ cursor: 'pointer' }}
                        onClick={() => handleEditHomework(payload.id)}
                     />
                  </Tooltip>
                  <Tooltip placement="top" title='Show Submissions'>
                     <AntDIcons.SolutionOutlined color='#4abec7' style={{ cursor: 'pointer' }}
                        onClick={() => handleHomeworkSubmissions(payload.id, payload.class_id, payload.title, payload.plagiarism_checker)}
                     />
                  </Tooltip>
                  <Tooltip placement="top" title='Duplicate'>
                     <Popconfirm
                        title="Create a copy of this project?"
                        onConfirm={() => handleDuplicateHomework(payload.id)}
                        okText="Yes"
                        cancelText="No"
                     >
                        <AntDIcons.CopyOutlined color={'#4abec7'} style={{ cursor: 'pointer' }} />
                     </Popconfirm>
                  </Tooltip>
                  <Tooltip placement="top" title='Remove'>
                     <Popconfirm
                        title="Are you sure you want to delete this project?"
                        onConfirm={() => handleRemoveHomework(payload.id)}
                        okText="Yes"
                        cancelText="No"
                     >
                        <AntDIcons.DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
                     </Popconfirm>
                     {/* <AntDIcons.DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleRemoveHomework(payload.id)} /> */}
                  </Tooltip>
               </Space>
            </>
         },
         width: '8%'
      },
   ].filter(item => !item.hidden);

   const handleSearchHomeworks = (userid) => {
      setHomeworkListLoading(true);
      var url = `${process.env.REACT_APP_API_HOMEWORK}/list?created_by=${userid}&level=${level}&section=${section}&subject=${subject}&type=project`;

      axios.get(url).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data;
            setHomeworkList(data);

            setHomeworkListLoading(false);
         }
      }, (error) => {
         setHomeworkListLoading(false);
         console.log(error.message);
      });
   }

   const renderTableSkeleton = () => (
      <div className="brainee-module-skeleton-table">
         <div className="brainee-module-skeleton-header">
            <Skeleton.Input active size="small" className="brainee-module-skeleton-title" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
         </div>
         {Array.from({ length: 7 }).map((_, index) => (
            <div className="brainee-module-skeleton-row" key={`projects-table-skeleton-${index}`}>
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell is-wide" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
            </div>
         ))}
      </div>
   );

   const handleCreateHomework = () => {
      setCreateModalVisible(true)
   }

   const handleEditHomework = (id) => {
      // axios.get(`${process.env.REACT_APP_API_HOMEWORK}/info?id=${id}`).then((response) => {
      //    if (response.data) {
      //       const data = response.data;
      //       // message.info(data[0]);
      //       setHomeworkData(data[0]);
      //       setHomeoworkID(id);
      //       setEditModalVisible(true);
      //    }
      // }, (error) => {
      //    console.log(error.message);
      // });

      setHomeoworkID(id);
      setEditModalVisible(true);
   }

   const handleHomeworkSubmissions = (homework_id, level_id, title, plagiarismChecker) => {
      setHomeworkTitle(title);
      setHomeoworkID(homework_id);
      setLevelSubmission(level_id);
      setPlagiarismCheckerEnabled(isPlagiarismCheckerEnabled(plagiarismChecker));
      setHSModalVisible(true);
   }

   // function RemoveHomework(id) {
   //    var url = `${process.env.REACT_APP_API_HOMEWORK}/remove?id=${id}`;

   //    return new Promise((resolve, reject) => {
   //       axios.post(url).then(response => {
   //          if (response.data) {
   //             handleSearchHomeworks();
   //             return true;
   //          }
   //       }, (error) => {
   //          //
   //          console.log(error);
   //          return false;
   //       });
   //    })

   // }

   const handleRemoveHomework = (id) => {
      setHomeworkListLoading(true);

      var url = `${process.env.REACT_APP_API_HOMEWORK}/remove?id=${id}`;
      axios.post(url).then(response => {
         if (response.data) {
            Modal.success({
               title: 'Project',
               content: 'Project successfully removed.',
               centered: true,
               onOk: handleSearchHomeworks(user_id)
            });
         }
      }, (error) => {
         //
         setHomeworkListLoading(false);
         console.log(error);
      });

      // Modal.confirm({
      //    title: 'Remove Homework',
      //    icon: <AntDIcons.ExclamationCircleOutlined />,
      //    content: 'Are you sure you want to remove this homework?',
      //    okText: 'Yes',
      //    cancelText: 'No',
      //    onOk() {
      //      return new Promise((resolve, reject) => {
      //          //  setTimeout(RemoveHomework(id) ? resolve : reject, 0);
      //          {
      //             if (RemoveHomework(id)) 
      //                return resolve;
      //             else return reject;
      //          }
      //      }).catch(() => console.log('Oops errors!'));
      //    },
      //    onCancel() {},
      //  });
   }

   const handleCancelCreate = () => {
      setCreateModalVisible(false);
   }

   const handleOnFinishCreate = (homeworkData, fileForUpload) => {
      setCreating(true);

      if (fileForUpload.length > 0) {
         var formData = new FormData();

         fileForUpload.forEach(file => {
            // the name has to be 'files' so that .NET could properly bind it (Phuck this sheet! Took me the whole day to find this sheet!)
            formData.append('files', file);
         });

         var uploadedfiles = "";
         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}`;
         axios.post(url, formData).then(response => {

            if (response.data) {
               uploadedfiles = response.data;

               homeworkData.document = uploadedfiles;

               var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
               axios.post(url, homeworkData).then(response => {
                  setCreating(false);
                  if (response.data) {
                     Modal.success({
                        title: 'Project',
                        content: 'Project created.',
                        centered: true,
                        onOk: () => { setCreateModalVisible(false) },
                     });

                     handleSearchHomeworks(user_id);
                  }
               }, (error) => {
                  setCreating(false);
                  Modal.error({
                     title: 'Project',
                     content: error.response.data,
                     centered: true,
                     onOk: () => { setCreateModalVisible(false) },
                  });
               });

            }
         }, (error) => {
            // console.log(error.message);
         });
      } else {
         var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
         axios.post(url, homeworkData).then(response => {
            setCreating(false);
            if (response.data) {
               Modal.success({
                  title: 'Project',
                  content: 'Project created.',
                  centered: true,
                  onOk: () => { setCreateModalVisible(false) },
               });

               handleSearchHomeworks(user_id);
            }

         }, (error) => {
            setCreating(false);
            Modal.error({
               title: 'Project',
               content: error.response.data,
               centered: true,
               onOk: () => { setCreateModalVisible(false) },
            });
         });
      }
   }

   const handleCancelEdit = () => {
      setEditModalVisible(false);
   }

   const handleOnFinishEdit = (homeworkData, filesForUpload) => {
      // message.info("Blah! Blah! Blah!");
      // setEditModalVisible(false);


      setUpdating(true);

      if (filesForUpload.length > 0) {
         var formData = new FormData();

         filesForUpload.forEach(file => {
            // the name has to be 'files' so that .NET could properly bind it (Phuck this sheet! Took me the whole day to figure out this sheet!)
            formData.append('files', file);
         });

         var uploadedfiles = "";
         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}`;
         axios.post(url, formData).then(response => {
            console.log(response);
            if (response.data) {
               uploadedfiles = response.data;

               homeworkData.document += homeworkData.document !== "" ? "," + uploadedfiles : uploadedfiles;

               var url = `${process.env.REACT_APP_API_HOMEWORK}/update`;
               axios.post(url, homeworkData).then(response => {
                  // console.log(response);

                  if (response.data) {
                     setUpdating(false);
                     Modal.success({
                        title: 'Project',
                        content: 'Project updated.',
                        centered: true,
                        onOk: () => { setEditModalVisible(false) },
                     });

                     handleSearchHomeworks(user_id);
                  }
               }, (error) => {
                  // console.log(error.message);
                  setUpdating(false);
                  Modal.error({
                     title: 'Project',
                     content: error.response.data,
                     centered: true
                  });
               });

            }
         }, (error) => {
            // console.log(error.message);
         });
      } else {
         var url = `${process.env.REACT_APP_API_HOMEWORK}/update`;
         axios.post(url, homeworkData).then(response => {
            console.log(response)
            if (response.data) {
               setUpdating(false);
               Modal.success({
                  title: 'Project',
                  content: 'Project updated.',
                  centered: true,
                  onOk: () => { setEditModalVisible(false) },
               });

               handleSearchHomeworks(user_id);
            }

         }, (error) => {
            console.log(error.message);
            setUpdating(false);
            Modal.error({
               title: 'Homework',
               content: error.response.data,
               centered: true,
               onOk: () => { setEditModalVisible(false) },
            });
         });
      }
   }

   const handleOnEvaluate = () => {

   }

   // const handleUserChange = (id) => {
   //    handleSearchHomeworks(id);
   //    setUserId(id);
   // }

   const handleDuplicateHomework = (id) => {
      axios.get(`${process.env.REACT_APP_API_HOMEWORK}/info?id=${id}`).then((response) => {
         if (response.data) {
            const homeworkdata = response.data[0];

            var o2o_mode = Utils.determineOnlineOffline(); //window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
            var homework_id = "project_" + o2o_mode + "_" + uuid();
            var utc = new Date().toJSON().slice(0, 19);

            let hwData = {
               id: homework_id,
               class_id: homeworkdata.class_id,
               session_id: 0, //api will take care of this
               title: homeworkdata.title + " - (" + utc + ")",
               homework_date: moment(homeworkdata.homework_date).format('YYYY-MM-DD HH:mm:ss'),
               submit_date: moment(homeworkdata.submit_date).format('YYYY-MM-DD HH:mm:ss'),
               subject_id: homeworkdata.subject_id,
               description: homeworkdata.description,
               created_by: homeworkdata.created_by,
               document: homeworkdata.document,
               sections: '', //section.join(','),
               assigned_students: '', //homeworkdata.assigned_students,
               students: '', //homeworkdata.students,
               max_points: homeworkdata.max_points,
               type: homeworkdata.type
            }

            var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
            axios.post(url, hwData).then(response => {
               setCreating(false);
               if (response.data) {
                  Modal.success({
                     title: 'Project',
                     content: 'Project duplication completed.',
                     centered: true,
                  });

                  handleSearchHomeworks(user_id);
               }
            }, (error) => {
               setCreating(false);
               Modal.error({
                  title: 'Project',
                  content: error.response.data,
                  centered: true,
               });
            });
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const getCardValue = (value) => {
      if (value === null || value === undefined || value === '') {
         return '—';
      }

      return value;
   };

   const renderCardField = (label, value, { fullWidth = false } = {}) => (
      <div className={`brainee-module-record-field${fullWidth ? ' is-full' : ''}`}>
         <span className="brainee-module-record-label">{label}</span>
         <span className="brainee-module-record-value">{getCardValue(value)}</span>
      </div>
   );

   const renderProjectCardActions = (payload) => (
      <Space size="small">
         <Tooltip placement="top" title='Edit'>
            <AntDIcons.EditOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleEditHomework(payload.id)} />
         </Tooltip>
         <Tooltip placement="top" title='Show Submissions'>
            <AntDIcons.SolutionOutlined color='#4abec7' style={{ cursor: 'pointer' }} onClick={() => handleHomeworkSubmissions(payload.id, payload.class_id, payload.title, payload.plagiarism_checker)} />
         </Tooltip>
         <Tooltip placement="top" title='Duplicate'>
            <Popconfirm
               title="Create a copy of this project?"
               onConfirm={() => handleDuplicateHomework(payload.id)}
               okText="Yes"
               cancelText="No"
            >
               <AntDIcons.CopyOutlined color={'#4abec7'} style={{ cursor: 'pointer' }} />
            </Popconfirm>
         </Tooltip>
         <Tooltip placement="top" title='Remove'>
            <Popconfirm
               title="Are you sure you want to delete this project?"
               onConfirm={() => handleRemoveHomework(payload.id)}
               okText="Yes"
               cancelText="No"
            >
               <AntDIcons.DeleteOutlined color='#4abec7' style={{ cursor: 'pointer' }} />
            </Popconfirm>
         </Tooltip>
      </Space>
   );

   const renderProjectCardList = () => (
      <div className="brainee-module-record-list-region">
         <div className="brainee-module-record-list">
            {homeworkList.map((record, index) => {
               const cardKey = record.uid || record.id || `project-card-${index}`;

               return (
                  <article className="brainee-module-record-card" key={cardKey}>
                     <div className="brainee-module-record-header">
                        <div className="brainee-module-record-heading">
                           <div className="brainee-module-record-header-row">
                              <span className="brainee-module-record-kicker">Project</span>
                              <span className="brainee-module-record-pill">{getCardValue(record.homework_date)}</span>
                           </div>
                           <h3>{getCardValue(record.title)}</h3>
                           <p>Submit by {getCardValue(record.submit_date)}</p>
                        </div>
                     </div>
                     <div className="brainee-module-record-meta">
                        {renderCardField('Level', record.level)}
                        {renderCardField('Sections', record.section_names, { fullWidth: true })}
                        {renderCardField('Subject', record.subject, { fullWidth: true })}
                        {renderCardField('Created By', record.teacher)}
                     </div>
                     <div className="brainee-module-record-actions">
                        {renderProjectCardActions(record)}
                     </div>
                  </article>
               );
            })}
         </div>
         <div className="brainee-module-record-list-footer">Total Records: {homeworkList.length}</div>
      </div>
   );
   return (
      <>

         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li className="active">Homeworks & Projects</li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: 'Brainee LMS' },
                        { key: 'ps', node: <Link to="/projectsubjects">Project Subjects</Link> },
                        { key: 'subject', node: subjectname },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div>
                     <span className="brainee-module-kicker">Projects</span>
                     <h1>{subjectname || 'Project List'}</h1>
                     <p>Review project activities, monitor submissions, and manage longer-form class work for this subject.</p>
                     <div className="brainee-module-meta">
                        <span><AntDIcons.ProjectOutlined /> {homeworkListLoading ? 'Loading records' : `${homeworkList.length} records`}</span>
                        <span><AntDIcons.ProfileOutlined /> Projects</span>
                     </div>
                  </div>
               </section>

               <section className="brainee-module-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Manage</span>
                        <h2>Project Records</h2>
                     </div>
                     <span className="brainee-module-count">{homeworkListLoading ? '...' : homeworkList.length}</span>
                  </div>

                  {homeworkListLoading
                     ? renderTableSkeleton()
                     : homeworkList.length > 0
                        ? (
                           isCompactListView
                              ? renderProjectCardList()
                              : <div className="brainee-module-table-shell">
                                 <Table
                                    className="brainee-module-table"
                                    rowKey={'uid'}
                                    size='small'
                                    columns={HomeworkListColumns}
                                    dataSource={homeworkList}
                                    pagination={false}
                                    scroll={{
                                       x: '1000px',
                                       y: 'calc(100svh - 20.5rem)',
                                    }}
                                    footer={() => <div className="brainee-module-table-footer">Total Records: {homeworkList.length}</div>}
                                 />
                              </div>
                        )
                        : <div className='brainee-module-state'>
                           <Empty image="../images/brainee_mascot.png" description="No records found" />
                        </div>
                  }
               </section>
            </div>
         </div>

         <Modal
            title={"Create Project"}
            // className="homework-assignment-modal"
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelCreate(); }}
            open={createModalVisible}
            width={1040}
            footer={[
               <Button key="cancel" onClick={handleCancelCreate} disabled={creating}>Cancel</Button>,
               <Button key="save" type="primary" htmlType="submit" form="project-create-form" loading={creating}>Save</Button>,
            ]}
         >
            <Spin spinning={creating} tip="Creating, please wait...">
               <Create
                  formId="project-create-form"
                  onCancelCallback={handleCancelCreate}
                  onFinishCallback={handleOnFinishCreate}
                  type='project'
               />
            </Spin>
         </Modal>

         <Modal
            title={"Edit Project"}
            // className="homework-assignment-modal"
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelEdit(); }}
            open={editModalVisible}
            width={1080}
            footer={[
               <Button key="cancel" onClick={handleCancelEdit} disabled={updating}>Cancel</Button>,
               <Button key="save" type="primary" htmlType="submit" form="project-edit-form" loading={updating}>Save</Button>,
            ]}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <Edit
                  formId="project-edit-form"
                  homeworkID={homeworkID}
                  homeworkData={homeworkData}
                  onCancelCallback={handleCancelEdit}
                  onFinishCallback={handleOnFinishEdit}
                  type='project'
               />
            </Spin>
         </Modal>

         <Modal
            title={"Project Submissions"}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={hsModalVisible}
            // width={window.innerWidth - 300}
            width='80%'
            onCancel={() => { setHSModalVisible(false); }}
            onOk={() => { setHSModalVisible(false); }}
         >
            {/* <Spin spinning={updating} tip={"Loading, please wait..."}> */}
            <Submissions
               homeworkTitle={homeworkTitle}
               homeworkID={homeworkID}
               levelID={levelSubmission}
               plagiarismCheckerEnabled={plagiarismCheckerEnabled}
               onEvaluateCallback={handleOnEvaluate}
               type='project'
            />
            {/* </Spin> */}
         </Modal>
      </>
   );
}

